/**
 * Keyed debouncer: collapses rapid bursts of calls that share the same key
 * into a single execution after `delay` ms of quiet. Used to coalesce
 * realtime-driven refetches so a burst of database changes results in one
 * data fetch instead of many (reducing database Disk IO).
 */
export function createKeyedDebouncer(defaultDelay = 700) {
  const timers = new Map<string, ReturnType<typeof setTimeout>>();

  return function debounce(key: string, fn: () => void, delay: number = defaultDelay) {
    const existing = timers.get(key);
    if (existing) {
      clearTimeout(existing);
    }
    timers.set(
      key,
      setTimeout(() => {
        timers.delete(key);
        fn();
      }, delay)
    );
  };
}
